<div class="chartmap-company">
  <button
    mat-icon-button
    class="isett"
    *ngIf="!(screenSize$ | async)?.isMobile && array_filter?.length > 1"
    (click)="menuFilter.open()"
  >
    <mat-icon>more_vert</mat-icon>
    <mat-select
      [formControl]="ifilter"
      multiple
      (openedChange)="iFilter($event)"
      #menuFilter
    >
      <mat-option *ngFor="let filter of array_filter" [value]="filter">
        {{ filter }}
      </mat-option>
    </mat-select>
  </button>

  <div class="company-row">
    <app-sentiment-events-mosaic
      [qparam]="qparam"
      [fetchParams]="mosaicParams"
      [nodata]="nodata"
      [loading]="loading"
      [iready]="iready"
      [visible]="iTool('Score Events') && effectiveScore === 'sentiment'"
    ></app-sentiment-events-mosaic>

    <app-score-events-mosaic
      [qparam]="qparam"
      [fetchParams]="mosaicParams"
      [nodata]="nodata"
      [loading]="loading"
      [iready]="iready"
      [eventsSortedBy]="eventsSortedBy"
      (eventsSortedByChange)="eventsSortedBy = $event"
      [scoreVisible]="iTool('Score Events') && effectiveScore !== 'sentiment'"
      [soleMosaic]="scoreEventsSole()"
    ></app-score-events-mosaic>

    <app-peergroup-comparison
      [qparam]="qparam"
      [fetchParams]="mosaicParams"
      [context]="peergroupCtx"
      [nodata]="nodata"
      [loading]="loading"
      [iready]="iready"
      [visible]="iTool('Peergroup Comparison') && !qparam?.score"
      (arrayFilterChange)="onArrayFilterChange($event)"
    ></app-peergroup-comparison>

    <div class="company-block" *ngIf="iTool('Entity') && !qparam?.score">
      <div class="company-menu">
        <div class="menu-logo" *ngIf="entity.logo">
          <img [src]="entity.logo" />
        </div>
        <div>
          <ng-container [ngSwitch]="entity.currency">
            <span *ngSwitchCase="'CHF'" class="price-tito"
              >₣{{ entity.price }}</span
            >
            <span *ngSwitchDefault class="price-tito">{{
              entity.price | currency: entity.currency
            }}</span>
          </ng-container>
          <span class="price-tino">{{ entity.price_change }}</span>
          <span class="price-tino">{{ entity.price_change_diff }}</span>
        </div>
      </div>
      <div class="company-treemap" *ngIf="iready['Entity']; else loadingEntity">
        <div
          class="treemap-item"
          [class.mobile]="(screenSize$ | async)?.isMobile"
          *ngFor="
            let item of treemapsort | slice: 0 : 7 | orderBy: 'item.sentiment'
          "
        >
          <div
            class="item-cont"
            (click)="iEntity(item.entity.type, item.entity.alpha_id)"
          >
            <div class="item-left">
              <div class="item-labe">
                {{ item.entity.type | nicetxt: false }}
              </div>
              <div [style.color]="item.sentiment | color">
                {{ item.entity.name }}
              </div>
            </div>
            <div class="item-rigt">
              <span class="perce">{{ item.sentiment | percent }}</span>
              <span
                class="trend"
                [style.color]="item.sentiment_delta | colorTrend"
                >{{ item.sentiment_delta | trend }}</span
              >
              <span class="spano">{{ iAbs(item.sentiment_delta) }} </span>
            </div>
          </div>
        </div>
        <div class="tab-loading" *ngIf="treemapLoading">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      </div>
      <ng-template #loadingEntity>
        <div class="loading" *ngIf="loading['Entity']">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>
        <div class="nodata" *ngIf="nodata['Entity']">NO DATA AVAILABLE</div>
      </ng-template>
    </div>
  </div>
</div>
